/**
 * ISO-8601 weekday names, Monday first — the order a rota is read in.
 *
 * One copy, because the editor and the quick-fill row both name days and two
 * lists drift the moment somebody shortens one of them.
 */
export const WEEKDAY_NAMES: Record<number, string> = {
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
  7: "Sunday",
};

/** §6.4's four day types, as a person reads them. The enum is structural. */
export const KIND_LABELS: Record<string, string> = {
  CLINIC: "Clinic",
  HALF_DAY: "Half day",
  TRAINING: "Training",
  OFF: "Off",
};
